import React from 'react';

export function IconTile({ icon }: { icon: React.JSX.Element }): React.JSX.Element {
	return (
		<div className="rounded-lg bg-blue-500 p-3 text-white lg:rounded-xl">
			<div className="iconContainer h-6 w-6 lg:h-10 lg:w-10">{icon}</div>
		</div>
	);
}
